<!-- <div class="card mb-0 border-0">
  <div class="card-body pb-1">

  </div>
</div> -->

<div class="payroll_main">
  <nav ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs gross_tabs">
    <ng-container [ngbNavItem]="1">
      <a ngbNavLink routerLink="/reports/labor/cashout" class="nav_txt"
        >{{ "Cashout" | translate | async }}</a
      >
    </ng-container>

    <ng-container [ngbNavItem]="2">
      <a ngbNavLink routerLink="/reports/labor/payroll" class="nav_txt"
        >{{ "Payroll" | translate | async }}</a
      >
      <ng-template ngbNavContent>
        <div class="row row-status mt-4">
          <div class="col-12 col-sm-10 d-flex gap-4 ps-0">
            <div class="row w-sm-auto w-100 m-sm-auto m-0">
              <div class="col-auto col-report">
                <div class="input-group mb-3 cusdaterangepicker w-auto">
                  <div
                    class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
                  >
                    <div
                      class="datepickerwrap form-control"
                      daterangepicker
                      [options]="options"
                      (applyDaterangepicker)="selectedDate($event, daterange)"
                      (click)="setDateTexts()"
                    >
                      <span class="date-text"
                        ><span class="display-date f-12 fw-500">{{
                          startDateDisplay | translate | async
                        }}</span>
                        -
                        <span class="display-date f-12 fw-500">{{
                          endDateDisplay | translate | async
                        }}</span></span
                      >
                      <img
                        src="../../../../assets/images/dashboard-images/bx-calendar.png"
                        class="picker-icon"
                        class="ms-2"
                      />
                    </div>
                  </div>
                  <div class="filter-btn" (click)="OpenFilterCanva(content)">
                    <button>
                      <img src="/assets/images/filter.svg" alt="filter" />
                    </button>
                  </div>
                </div>
                <div class="">
                  <ng-template #content let-offcanvas>
                    <div class="Filter-Canvas-open cashout-filter">
                      <div
                        class="action-data"
                        *ngIf="OpenDetails === 'mainMenu'"
                      >
                        <h2 class="mb-0">Filters</h2>
                        <button
                          type="button"
                          class="btn-close"
                          aria-label="Close"
                          (click)="offcanvas.dismiss('Cross click')"
                        ></button>
                      </div>
                      <div
                        class="back-time"
                        *ngIf="OpenDetails === 'StartEndDate'"
                        (click)="OpenDetails = 'mainMenu'"
                      >
                        <i class="fa-solid fa-arrow-left f-20"></i>
                        <p class="f-14 fw-600 mb-0">
                          {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                        </p>
                      </div>
                      <!-- select payment -->
                      <div
                        class="back-time"
                        *ngIf="OpenDetails === 'SelectEmployee'"
                        (click)="OpenDetails = 'mainMenu'"
                      >
                        <i class="fa-solid fa-arrow-left f-20"></i>
                        <p class="f-14 fw-600 mb-0">{{ "Select Employee" | translate | async }}</p>
                      </div>
                      <!-- End payment -->

                      <!-- instDiscount -->
                      <div
                        class="back-time"
                        *ngIf="OpenDetails === 'instDiscount'"
                        (click)="OpenDetails = 'mainMenu'"
                      >
                        <i class="fa-solid fa-arrow-left f-20"></i>
                        <p class="f-14 fw-600 mb-0">{{ "instDiscount" | translate | async }}</p>
                      </div>
                      <div
                        class="back-time"
                        *ngIf="OpenDetails === 'selecttrip'"
                        (click)="OpenDetails = 'mainMenu'"
                      >
                        <i class="fa-solid fa-arrow-left f-20"></i>
                        <p class="f-14 fw-600 mb-0">{{ "Select Tip" | translate | async }}</p>
                      </div>
                      <!-- End instdixcount -->
                      <!-- Export -->
                      <div
                        class="back-time"
                        *ngIf="OpenDetails === 'ExportDetails'"
                        (click)="OpenDetails = 'mainMenu'"
                      >
                        <i class="fa-solid fa-arrow-left f-20"></i>
                        <p class="f-14 fw-600 mb-0">{{ "Export" | translate | async }}</p>
                      </div>
                      <!-- End export -->
                      <div class="action-list">
                        <!-- Button MAin -->
                        <div class="">
                          <div class="d-inline-block in-bott">
                            <button
                              (click)="OpenDetails = 'StartEndDate'"
                              type="button"
                              class="btn f-14 fw-500 sec-btn mb-14"
                              id="dropdownBasic1"
                              *ngIf="OpenDetails === 'mainMenu'"
                            >
                              {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                              <i class="fa-solid fa-chevron-right"></i>
                            </button>
                          </div>
                          <div
                            *ngIf="OpenDetails === 'mainMenu'"
                            class="d-inline-block mb-14 in-bott"
                            (click)="OpenDetails = 'SelectEmployee'"
                          >
                            <button
                              type="button"
                              class="btn f-14 fw-500 sec-btn"
                              id="dropdownBasic1"
                            >
                              {{ "Select Employee" | translate | async }}
                              <i class="fa-solid fa-chevron-right"></i>
                            </button>
                          </div>
                          <div
                            *ngIf="OpenDetails === 'mainMenu'"
                            class="d-inline-block mb-14 in-bott"
                          >
                            <button
                              (click)="OpenDetails = 'selecttrip'"
                              type="button"
                              class="btn f-14 fw-500 sec-btn"
                              id="dropdownBasic1"
                            >
                              {{ "Select Tip" | translate | async }}
                              <i class="fa-solid fa-chevron-right"></i>
                            </button>
                            <!-- <div
                              class="sec-discount f-14 align-items-center d-flex gap-14 detalis pl-0 justify-content-between"
                            >
                              <label class="mb-0">Select Tip</label>
                              <ui-switch
                                defaultBoColor="#dfdfdf"
                                color="#666666"
                                size="small"
                              ></ui-switch>
                            </div> -->
                          </div>
                          <div
                            *ngIf="OpenDetails === 'mainMenu'"
                            class="d-inline-block in-bott"
                          >
                            <button
                              (click)="OpenDetails = 'ExportDetails'"
                              type="button"
                              class="btn f-14 fw-500 sec-btn"
                              id="dropdownBasic1"
                            >
                              {{ "Export" | translate | async }}
                              <i class="fa-solid fa-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                        <!-- End button main -->
                        <!-- startDate-EndDate -->
                        <div class="" *ngIf="OpenDetails === 'StartEndDate'">
                          <div>
                            <div
                              class="d-flex justify-content-between f-12 fw-500"
                            >
                              <div class="me-2 ms-2 mt-3">
                                <p>{{ "Start" | translate | async }}</p>
                              </div>
                              <div class="p-2">
                                <select
                                  class="form-select f-12 fw-500"
                                  id="Select1"
                                  [(ngModel)]="startTime"
                                >
                                  <option
                                    [value]="startDate.id"
                                    *ngFor="let startDate of dateTimeArray"
                                  >
                                    {{ startDate.text }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-between f-12 fw-500"
                            >
                              <div class="me-2 ms-2 mt-3">
                                <p>{{ "End" | translate | async }}</p>
                              </div>
                              <div class="p-2">
                                <select
                                  id="Select2"
                                  [(ngModel)]="endTime"
                                  class="form-select f-12 fw-500"
                                >
                                  <option
                                    [value]="endDate.id"
                                    *ngFor="let endDate of dateTimeArray"
                                  >
                                    {{ endDate.text }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-between f-12 fw-500"
                            >
                              <div class="me-2 ms-2 mt-1" (click)="ClosingDay='Same Day'">
                                <input
                                  class="form-check-input custom-form-radio me-2"
                                  type="radio"
                                  id="Second1"
                                  value="Same Day"
                                  [(ngModel)]="ClosingDay"
                                  [checked]="sameDayIsChecked()"
                                  (ngModelChange)="selectClosingDay($event)"
                                  [ngClass]="{'checkedRadio': ClosingDay === 'Same Day'}"
                                />
                                <label class="form-check-label" for="Second2">
                                  {{ "Same Day" | translate | async }}
                                </label>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-between f-12 fw-500"
                            >
                              <div class="me-2 ms-2 mt-1" (click)="ClosingDay='Next Day'">
                                <input
                                  class="form-check-input custom-form-radio me-2"
                                  type="radio"
                                  id="Second2"

                                  value="Next Day"
                                  [(ngModel)]="ClosingDay"
                                  [checked]="nextDayIsChecked()"
                                  (ngModelChange)="selectClosingDay($event)"
                                  [ngClass]="{'checkedRadio': ClosingDay === 'Next Day'}"
                                />
                                <label class="form-check-label" for="Second2">
                                  {{ "Next Day" | translate | async }}
                                  <i
                                    class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]="'Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Next Day' | translate | async"
                                    data-bs-placement="right"
                                  ></i>
                                </label>
                              </div>
                            </div>
                            <div class="f-12 fw-500">
                              <div class="me-2 ms-2 mt-1">
                                <button
                                  accessControl
                                  module="PayrollReport"
                                  access="3"
                                  class="btn btn-dark btn-block btn-sm w-100"
                                  (click)="timeFilter(); myDrop.close()"
                                  [disabled]="
                                    (ClosingDay == 'Next Day' &&
                                      startDateDisplay == endDateDisplay) ||
                                    (ClosingDay == 'Same Day' &&
                                      timeDiasbleValidation())
                                  "
                                >
                                  {{ "Apply" | translate | async }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- End -->

                        <!-- Select Employee  -->
                        <div *ngIf="OpenDetails === 'SelectEmployee'">
                          <div class="search-main mb-20">
                            <input
                              id="search"
                              type="text"
                              class="search-box"
                              [placeholder]="'Search' | translate | async"
                              [(ngModel)]="searchTerm"
                              (keyup)="onSearch()"
                            />
                            <i
                              class="fa-solid fa-magnifying-glass search-icon"
                            ></i>
                            <i
                              class="fa-solid fa-xmark sraech-close closeicon"
                              style="cursor: pointer"
                              *ngIf="searchTerm != ''"
                              (click)="onCrossButtonClick()"
                            ></i>
                          </div>
                          <div *ngIf="!ishown" class="">
                            <div
                              class="d-flex gap-14 align-items-center detalis mb-20"
                            >
                              <input
                                type="checkbox"
                                id="Selectall"
                                [(ngModel)]="ischeked"
                                (change)="addnewEmployeeFilter('all')"
                              />
                              <label
                                for="Selectall"
                                class="m-0 f-14 fw-500 s-all"
                                >{{ "Select all" | translate | async }}
                              </label>
                            </div>
                            <div
                              class=""
                              *ngFor="let employee of EmployeefilteredData"
                            >
                              <div
                                class="detalis mb-20 d-flex gap-14 align-items-center"
                                *ngIf="!ishown"
                              >
                                <input
                                  type="checkbox"
                                  id="{{ employee.id }}"
                                  [checked]="findEmployeeCheck(employee.id)"
                                  (change)="addnewEmployeeFilter(employee)"
                                />
                                <label
                                  for="{{ employee.id }}"
                                  class="f-14 fw-500 m-0"
                                  >{{ employee.name }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="ishown">
                            <p>{{ "No filtered data available" | translate | async }}</p>
                          </div>
                        </div>
                        <!-- End payemt -->
                        <div *ngIf="OpenDetails === 'selecttrip'">
                          <div class="" *ngFor="let p of Newselecttip">
                            <div
                              class="detalis mb-20 d-flex gap-14 align-items-center"
                              (click)="ChnageSelectTip(p.value)"
                            >
                              <span class="f-14 fw-500">{{ p.name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Export -->
                      <div class="" *ngIf="OpenDetails === 'ExportDetails'">
                        <div
                          class="d-flex align-items-center gap-12 p-btn mt-10"
                          (click)="openModalSubscribe(content1)"
                        >
                          <img
                            src="/assets/images/expo-system.svg"
                            alt="expo"
                          />
                          <p class="f-14 fw-500 black mb-0">
                            {{ "Subscribe to Email" | translate | async }}
                          </p>
                        </div>
                        <div
                          class="d-flex align-items-center gap-12 p-btn"
                          (click)="openModalEmail(sendEmail)"
                        >
                          <img src="/assets/images/expo-mail.png" alt="expo" />
                          <p class="f-14 fw-500 black mb-0">{{ "Send to Email" | translate | async }}</p>
                        </div>
                        <div
                          class="d-flex align-items-center gap-12 p-btn"
                          (click)="donwloadFile('pdf')"
                        >
                          <img src="/assets/images/pdf-expo.svg" alt="expo" />
                          <p class="f-14 fw-500 black mb-0">{{ "Export PDF" | translate | async }}</p>
                        </div>
                        <div
                          class="d-flex align-items-center gap-12 p-btn"
                          (click)="donwloadFile('csv')"
                        >
                          <img src="/assets/images/csv-expo.svg" alt="expo" />
                          <p class="f-14 fw-500 black mb-0">{{ "Export CSV" | translate | async }}</p>
                        </div>
                        <div
                          class="d-flex align-items-center gap-12 p-btn"
                          (click)="donwloadFile('excel')"
                        >
                          <img src="/assets/images/excel-expo.svg" alt="expo" />
                          <p class="f-14 fw-500 black mb-0">{{ "Export Excel" | translate | async }}</p>
                        </div>
                      </div>
                      <!-- End export -->
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="col-auto col-report mob-report">
                <div class="input-group mb-3 f-12 fw-500">
                  <div
                    accessControl
                    module="PayrollReport"
                    access="3"
                    ngbDropdown
                    #myDrop="ngbDropdown"
                    class="d-inline-block w-100"
                  >
                    <button
                      accessControl
                      module="PayrollReport"
                      access="3"
                      type="button"
                      class="btn f-12 fw-500 sec-btn in-bott"
                      id="dropdownBasic1"
                      ngbDropdownToggle
                    >
                      {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-chevron-down"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        [class.rotate-up]="myDrop.isOpen()"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </button>
                    <div
                      ngbDropdownMenu
                      aria-labelledby="dropdownBasic1"
                      style="min-width: 262px"
                      (click)="isDropdownOpen1 = false"
                    >
                      <div class="d-flex justify-content-between f-12 fw-500">
                        <div class="me-2 ms-2 mt-3">
                          <p>{{ "Start" | translate | async }}</p>
                        </div>
                        <div class="p-2 start-Date-new">
                          <ng-select
                            class="form-select f-12 fw-500"
                            id="Select1"
                            [(ngModel)]="startTime"
                            style="width: 100px !important;"
                          >
                            <ng-option
                              [value]="startDate.id"
                              *ngFor="let startDate of dateTimeArray"
                            >
                              {{ startDate.text }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between f-12 fw-500">
                        <div class="me-2 ms-2 mt-3">
                          <p>{{ "End" | translate | async }}</p>
                        </div>
                        <div class="p-2 End-Date-new">
                          <ng-select
                            id="Select2"
                            [(ngModel)]="endTime"
                            class="form-select f-12 fw-500"
                            style="width: 100px !important;"
                          >
                            <ng-option
                              [value]="endDate.id"
                              *ngFor="let endDate of dateTimeArray"
                            >
                              {{ endDate.text }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between f-12 fw-500">
                        <div class="me-2 ms-2 mt-1" (click)="ClosingDay='Same Day'">
                          <input
                            class="form-check-input custom-form-radio me-2"
                            type="radio"
                            id="Second1"
                            value="Same Day"
                            [(ngModel)]="ClosingDay"
                            [checked]="sameDayIsChecked()"
                            [ngClass]="{'checkedRadio': ClosingDay === 'Same Day'}"
                            (ngModelChange)="selectClosingDay($event)"
                            [ngClass]="{'checkedRadio': ClosingDay === 'Same Day'}"
                          />
                          <label class="form-check-label" for="Second2">
                            {{ "Same Day" | translate | async }}
                          </label>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between f-12 fw-500">
                        <div class="me-2 ms-2 mt-1" (click)="ClosingDay='Next Day'">
                          <input
                            class="form-check-input custom-form-radio me-2"
                            type="radio"
                            id="Second2"
                            name="closingDay"
                            value="Next Day"
                            [(ngModel)]="ClosingDay"
                            [checked]="nextDayIsChecked()"
                            [ngClass]="{'checkedRadio': ClosingDay === 'Next Day'}"
                            (ngModelChange)="selectClosingDay($event)"
                          />
                          <label class="form-check-label" for="Second2">
                            {{ "Next Day" | translate | async }}
                            <i
                              class="f-10 fas fa-info-circle vertical-align-super"
                              [ngbPopover]="'Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation' | translate | async"
                              triggers="mouseenter:mouseleave"
                              [popoverTitle]="'Next Day' | translate | async"
                              data-bs-placement="right"
                            ></i>
                          </label>
                        </div>
                      </div>
                      <div class="f-12 fw-500">
                        <div class="me-2 ms-2 mt-1">
                          <button
                            accessControl
                            module="PayrollReport"
                            access="3"
                            class="btn btn-dark btn-block btn-sm w-100 d-flex justify-content-center "
                            (click)="timeFilter(); myDrop.close()"
                            [disabled]="
                              (ClosingDay == 'Next Day' &&
                                startDateDisplay == endDateDisplay) ||
                              (ClosingDay == 'Same Day' &&
                                timeDiasbleValidation())
                            "
                          >
                            {{ "Apply" | translate | async }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto col-report mob-report">
                <div class="input-group mb-3">
                  <div
                    ngbDropdown
                    class="d-inline-block fw-500 f-12 m-auto w-100"
                    style="font-weight: 500"
                  >
                    <div id="drop1">
                      <ng-multiselect-dropdown
                        [placeholder]="'Select Employee' | translate | async"
                        [settings]="dropdownSettings"
                        (onSelect)="this.addEmployeeFilter($event.id, true)"
                        (onSelectAll)="this.addEmployeeFilter('all', true)"
                        (onDeSelectAll)="this.addEmployeeFilter('all', false)"
                        (onDeSelect)="this.addEmployeeFilter($event.id, false)"
                        [data]="listOfemployees"
                      >
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto d-inline-block col-report mob-report">
                <div class="input-group mb-3">
                  <select
                    class="form-select"
                    aria-label="Default select example"
                    style="font-size: 12px; font-weight: 500; padding: 8px"
                    (change)="changeTip($event.target.value)"
                  >
                    <!-- SHOULD NOT BE DISABLED, SO USER CAN SELECT NO CATEGORY -->
                    <option [value]="null" selected>{{ "Select Tip" | translate | async }}</option>
                    <option [value]="true">{{ "Tipout" | translate | async }}</option>
                    <option [value]="false">{{ "No Tipout" | translate | async }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 col-sm-2 d-flex justify-content-sm-end mb-3 drop-expo mob-report"
          >
            <div
              accessControl
              module="PayrollReport"
              access="3"
              ngbDropdown
              class="d-inline-block"
              style="height: 39px"
            >
              <!-- Removed from button: accessControl access="3" -->
              <button
                [disabled]="emptydata"
                (click)="toggleDropdown()"
                module="PayrollReport"
                type="button"
                class="btn f-12 fw-500 sec-btn"
                id="dropdownBasic1"
                ngbDropdownToggle
                (blur)="isDropdownOpen = false"
              >
                {{ "Export" | translate | async }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-chevron-down"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  [class.rotate-up]="isDropdownOpen"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="openModalSubscribe(content1)">
                  {{ "Subscribe to Email" | translate | async }}
                </button>
                <button ngbDropdownItem (click)="openModalSchedule(contentSchedule)">
                  {{ "Schedule Report" | translate | async }}
                </button>
                <button ngbDropdownItem (click)="openModalEmail(sendEmail)">
                  {{ "Send to Email" | translate | async }}
                </button>
                <button ngbDropdownItem (click)="donwloadFile('pdf')">
                  {{ "Export PDF" | translate | async }}
                </button>
                <button ngbDropdownItem (click)="donwloadFile('csv')">
                  {{ "Export CSV" | translate | async }}
                </button>
                <button ngbDropdownItem (click)="donwloadFile('excel')">
                  {{ "Export Excel" | translate | async }}
                </button>
              </div>
            </div>
            <!-- <div class="menu_them">
              <button class="menu_btn"><i class="fa-solid fa-ellipsis-vertical"></i></button>
            </div> -->
          </div>
        </div>
        <!-- <div *ngIf="!emptydata" class="d-flex payroll_summary justify-content-between">
          <div>
            <h4 class="f-18 fw-600">Payroll Summary</h4>
          </div>
         <div class="d-flex table_detalis">
          <div class="d-flex summery_detalis justify-content-between">
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">Jobs</p>
              <p class="text-black f-14 fw-600">0</p>
            </div>
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">Time</p>
              <p class="text-black f-14 fw-600">0</p>
            </div>
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">Regular</p>
              <p class="text-black f-14 fw-600">0</p>
            </div>
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">O/T</p>
              <p class="text-black f-14 fw-600">00.00</p>
            </div>
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">D/T</p>
              <p class="text-black f-14 fw-600">$00.00</p>
            </div>
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">Tip</p>
              <p class="text-black f-14 fw-600">$00.00</p>
            </div>
            <div class="m-0">
              <p class="text-black f-14 fw-600 opacity-50">Total</p>
              <p class="text-black f-14 fw-600">$00.00</p>
            </div>
          </div>
          <div>
            <button class="arrow_btn"><i class="fa-sharp fa-solid fa-chevron-down"></i></button>
          </div>
         </div>
        </div> -->
        <div *ngIf="!emptydata" class="payroll-accordion-dropdown-arrow">
          <div class="mb-3" *ngFor="let employees of data">
            <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
              <ngb-panel id="ngb-panel-0">
                <ng-template ngbPanelTitle>
                  <div>
                    <div class="ts f-14">
                      <!-- {{employees.workingHours[0].job}} &nbsp; -->
                    </div>
                    <div class="f-18 fw-600 mb-3">
                      {{ employees.name }}
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="table-responsive report_table mb-4">
                    <table class="w-100">
                      <thead>
                        <tr>
                          <th>{{ "Employee Id" | translate | async }}</th>
                          <th class="text-center">{{ "Date Created" | translate | async }}</th>
                          <th class="text-center">{{ "Job" | translate | async }}</th>
                          <th class="text-center">{{ "Department" | translate | async }}</th>
                          <th class="text-center">{{ "Rate" | translate | async }}</th>
                          <th class="text-center">{{ "Clock In" | translate | async }}</th>
                          <th class="text-center">{{ "Clock out" | translate | async }}</th>
                          <th class="text-center">{{ "Regular" | translate | async }}</th>
                          <th class="text-center">{{ "O/T" | translate | async }}</th>
                          <th class="text-center">{{ "D/T" | translate | async }}</th>
                          <th class="text-center">{{ "Cost" | translate | async }}</th>
                          <th class="text-center" *ngIf="this.tipout">{{ "Tip" | translate | async }}</th>
                          <th class="text-center">{{ "Service charge(as Tips)" | translate | async }}</th>
                          <th class="text-center">{{ "Total Tips" | translate | async }}</th>
                          <th class="text-end">{{ "Total" | translate | async }}</th>
                        </tr>
                      </thead>
                      <tbody >
                        <tr *ngFor="let working of employees.workingHours">
                          <td>{{ working.number }}</td>
                          <td class="text-center">{{ working.date }}</td>
                          <td class="text-center">{{ working.job | translate | async }}</td>
                          <td class="text-center">{{ working.deparment | translate | async }}</td>
                          <td class="text-center">{{ working.rate }}</td>
                          <td class="text-center">{{ working.clockIn | translate | async }}</td>
                          <td class="text-center">{{ working.clockOut | translate | async }}</td>
                          <td class="text-center">{{ calculateTimeDifference(working.clockIn, working.clockOut) | translate | async }}</td>
                          <td class="text-center">{{ working.overTime }}</td>
                          <td class="text-center">{{ working.doubleTime }}</td>
                          <td class="text-center">
                            {{ currency }}{{ working.cost }}
                            <!-- {{ working.cost | currency }} -->
                          </td>
                          <td class="text-center" *ngIf="this.tipout">
                            {{ currency }}{{ working.tip }}
                            <!-- {{ working.tip | currency }} -->
                          </td>
                          <td class="text-center">
                            {{ currency }}{{ working.serviceTip }}
                            <!-- {{ working.serviceTip | currency }} -->
                          </td>
                          <td class="text-center">
                            {{ currency }}{{ working.totalTip }}
                            <!-- {{ working.totalTip | currency }} -->
                          </td>
                          <td class="text-end">
                            {{ currency }}{{ working.total }}
                            <!-- {{ working.total | currency }} -->
                          </td>
                        </tr>
                      </tbody>
                      <tbody *ngFor="let subtotals of employees.subtotals">
                        <tr class="sub-total" *ngIf="subtotals.name">
                          <th colspan="7">{{ subtotals.name | translate | async }}</th>
                          <th class="text-center">{{ subtotals.regular | translate | async }}</th>
                          <!-- <th class="text-center">{{ formatRegularSubTotal(subtotals.regular) }}</th> -->
                          <th class="text-center">{{ subtotals.overTime }}</th>
                          <th class="text-center">
                            {{ subtotals.doubleTime }}
                          </th>
                          <th class="text-center">
                            {{ currency }}{{ subtotals.cost }}
                            <!-- {{ subtotals.cost | currency }} -->
                          </th>
                          <th class="text-center" *ngIf="this.tipout">
                            {{ currency }}{{ subtotals.tip }}
                            <!-- {{ subtotals.tip | currency }} -->
                          </th>
                          <th class="text-center">
                            {{ currency }}{{ subtotals.serviceTip }}
                            <!-- {{ subtotals.serviceTip | currency }} -->
                          </th>
                          <th class="text-center">
                            {{ currency }}{{ subtotals.totalTip }}
                            <!-- {{ subtotals.totalTip | currency }} -->
                          </th>
                          <th class="text-end">
                            {{ currency }}{{ subtotals.total }}
                            <!-- {{ subtotals.total | currency }} -->
                          </th>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr class="sub-total">
                          <th colspan="7">{{ "Total" | translate | async }}</th>
                          <th class="text-center">
                            {{ employees.total.regular }}
                          </th>
                          <th class="text-center">
                            {{ employees.total.overTime }}
                          </th>
                          <th class="text-center">
                            {{ employees.doubleTime ?? "0.00"}}
                          </th>
                          <th class="text-center">
                            {{ currency }}{{ employees.total.cost }}
                            <!-- {{ employees.total.cost | currency }} -->
                          </th>
                          <th class="text-center" *ngIf="this.tipout">
                            {{ currency }}{{ employees.total.tip }}
                            <!-- {{ employees.total.tip | currency }} -->
                          </th>
                          <th class="text-center">
                            {{ currency }}{{ employees.total.serviceTip }}
                            <!-- {{ employees.total.serviceTip | currency }} -->
                          </th>
                          <th class="text-center">
                            {{ currency }}{{ employees.total.totalTip }}
                            <!-- {{ employees.total.totalTip | currency }} -->
                          </th>
                          <th class="text-end">
                            {{ currency }}{{ employees.total.total }}
                            <!-- {{ employees.total.total | currency }} -->
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>

        <div *ngIf="emptydata" class="reports-no-discounts">
          <div class="empty-discounts-note">
            <img
              src="assets/images/payroll.png"
              alt="Empty Report Icon"
              class="payroll-data"
            />
            <div class="mt-3">
              {{ "No Payroll took place during the time frame you selected." | translate | async }}
            </div>
            <div>{{ "Please select a different range" | translate | async }}</div>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-container [ngbNavItem]="3">
      <a ngbNavLink routerLink="/reports/labor/tip-report" class="nav_txt"
        >{{ "Tip" | translate | async }}</a
      >
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<ng-template #content1 let-c="close" let-d class="">
  <div class="modal-body update_num">
    <div class="d-flex justify-content-between mb-4">
      <div class="f-20 fw-600">{{ "SUBCRIBE TO EMAIL" | translate | async }}</div>
      <div>
        <img
          src="assets\images\closeIcon.svg"
          class="cursor-pointer"
          (click)="cancel()"
        />
        <!-- (click)="d.dismiss('Cross click')" -->
      </div>
    </div>
    <form [formGroup]="subForm">
      <div>
        <div class="mb-3">
          <div id="drop2">
            <ng-multiselect-dropdown
              [placeholder]="'Select Employee' | translate | async"
              [settings]="dropdownSettings"
              [formControl]="multiselectControl"
              (onSelect)="this.createSubscribe($event.id, true)"
              (onSelectAll)="this.selectAllSubscribe(true)"
              (onDeSelect)="this.createSubscribe($event.id, false)"
              (onDeSelectAll)="this.selectAllSubscribe(false)"
              [data]="listOfemployees"
            >
            </ng-multiselect-dropdown>
            <!-- Show an error message if the dropdown is invalid -->
            <div
              *ngIf="
                employeeError
              "
            >
              <div class="form-text text-danger">
                {{ "Please select at least one employee." | translate | async }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <button
              *ngIf="!isLoading"
              class="primary_btn f-18 w-100 fw-700 text-white"
              type="submit"
              (click)="subscribeEmployees()"
            >
              {{ "Subscribe" | translate | async }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #contentSchedule let-c="close" let-d class="">
  <div class="modal-body update_num">
    <div class="d-flex justify-content-between mb-4">
      <div class="f-20 fw-600">{{ "SCHEDULE A REPORT" | translate | async }}</div>
      <div>
        <img
          src="assets\images\closeIcon.svg"
          class="cursor-pointer"
          (click)="cancel2()"
        />
        <!-- (click)="d.dismiss('Cross click')" -->
      </div>
    </div>
    <form>
      <div>
        <div class="mb-3">
          <label for="coursename" class="form-label"
              >{{ 'Select Employee*' | translate | async }}<img src="assets\images\!.png"
            /></label>
          <div id="drop4">
            <ng-multiselect-dropdown
              [placeholder]="'Select Employee' | translate | async"
              [settings]="dropdownSettings"
              [(ngModel)]="scheduleEmployee"
              [ngModelOptions]="{ standalone: true }"
              (onSelect)="this.createSubscribe($event.id, true)"
              (onSelectAll)="this.selectAllSubscribe(true)"
              (onDeSelect)="this.createSubscribe($event.id, false)"
              (onDeSelectAll)="this.selectAllSubscribe(false)"
              [data]="listOfemployees"
            >
            </ng-multiselect-dropdown>
            <!-- Show an error message if the dropdown is invalid -->
            <div
              *ngIf="
               employeeError
              "
            >
              <div class="form-text text-danger">
                {{ "Please select at least one employee." | translate | async }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-6"> -->
            <div class="mb-3">
              <label for="coursename" class="form-label"
              >{{ 'Select frequency*' | translate | async }}<img src="assets\images\!.png"
            /></label>
            <div id="drop4">
              <ng-multiselect-dropdown
                [placeholder]="'Select Frequency' | translate | async"
                [settings]="freqdropdownSettings"
                [(ngModel)]="frequency"
                (onSelect)='checkTimeValidation(true)'
                (onSelectAll)='checkTimeValidation(true)'
                (onDeSelect)='checkTimeValidation(false)'
                (onDeSelectAll)='checkTimeValidationDeSelectAll(false)'
                [ngModelOptions]="{ standalone: true }"
                [data]="freqList"
              >
              </ng-multiselect-dropdown>
              <!-- Show an error message if the dropdown is invalid -->
              <div
              *ngIf="
               frequencyErr
              "
            >
              <div class="form-text text-danger">
                {{ "Please select Frequency." | translate | async }}
              </div>
              </div>
            </div>
            </div>
          <!-- </div> -->
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <button

              class="primary_btn f-18 w-100 fw-700 text-white"
              type="submit"
              (click)="scheduleReport()"
            >
              {{ "Schedule" | translate | async }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #sendEmail role="document" let-modal>
  <div class="modal-body update_num">
    <div class="d-flex justify-content-between mb-4">
      <div class="f-20 fw-600">{{ "Send to Email" | translate | async }}</div>
      <div>
        <img
          src="assets\images\closeIcon.svg"
          class="cursor-pointer"
          (click)="modal.dismiss('Cross click'); emailForm.reset()"
        />
      </div>
    </div>
    <div [formGroup]="emailForm">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input
          type="email"
          class="form-control"
          id="email"
          [placeholder]="'Enter Email' | translate | async"
          formControlName="email"
        />
        <div
          class="form-text text-danger"
          *ngIf="
            !emailForm.get('email').valid && emailForm.get('email').touched
          "
        >
          {{ "Please enter valid email." | translate | async }}
        </div>
      </div>
      <div class="mb-4">
        <label for="cc" class="form-label">{{ "Enter CC" | translate | async }}</label>
        <input
          type="email"
          class="form-control"
          id="cc"
          [placeholder]="'Enter CC' | translate | async"
          formControlName="emailCC"
        />
        <div
          class="form-text text-danger"
          *ngIf="
            !emailForm.get('emailCC').valid && emailForm.get('emailCC').touched
          "
        >
          {{ "Please enter valid email." | translate | async }}
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <!-- <button accessControl
        module="PayrollReport"
        access=3 type="submit" class="primary_btn f-18 w-100 fw-700 text-white" [disabled]="emailForm.invalid" (click)="modal.close('Send')">
          Send
        </button> -->
        <button
          type="submit"
          class="primary_btn f-18 w-100 fw-700 text-white"
          [disabled]="emailForm.invalid"
          (click)="modal.close('Send')"
        >
          {{ "Send" | translate | async }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
